module.exports = __webpack_public_path__ + "static/media/luberly_cover.80638d83.png";